import axios from '@/helpers/http-common';


const index = (page: number = 1, perPage: number = 10, search: string = '', canceled: boolean = false) => {
    return axios.get(`/contracts?page=${page}&per_page=${perPage}&search=${search}&canceled=${canceled}`);
};

export const contractService = {
    index,
};
